export default __webpack_public_path__ + "static/media/blog-driveway-cost-002.f85a7d9d.jpg";